export class SearchParameter {
  public engineType: string;
  constructor(public searchString: string) { }
}
